import React, { useEffect, useState } from "react";
import CircularGaugeChart from "../../../CHARTS/CircularGaugeChart";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";
import { PiTargetDuotone } from "react-icons/pi";
const CHWeightTargetPercentageData = ({
  chartData,
  setTwoCommodityTargetAchieved,
  yearData,
  setyearData,
}) => {
  const [commodityTargetAchieved, setCommodityTargetAchieved] = useState([]);
  useEffect(() => {
    if (chartData) {
      const targetAchieved = [];
      const targetedYear = chartData.dimensions.find((year) =>
        year.includes("_target")
      );
      const year = targetedYear?.replace("_target", "");
      chartData?.series.forEach((dataObj) => {
        targetAchieved.push({
          ...dataObj,
          targetAchieved: (
            (Number(dataObj[year]) / Number(dataObj[targetedYear])) *
            100
          ).toFixed(2),
        });
      });
      setyearData([year, targetedYear]);
      setCommodityTargetAchieved(targetAchieved);
    }
  }, [chartData]);
  return (
    <div className="m-1">
      {" "}
      <h6 className="m-1 p-2 bg-dark text-white scrollspy">
        <PiTargetDuotone /> Target Achieved
      </h6>
      <div
        className=""
        style={{
          overflowX: "auto", // enable horizontal scroll
          overflowY: "hidden",

          whiteSpace: "nowrap", // prevent wrapping
          maxWidth: "100vw", // max container width
          height: "220px", // adjusted for chart height
        }}
      >
        {chartData?.series?.length <= 0 ? (
          <b style={{ color: "red" }}>No Data Found !</b>
        ) : null}

        {commodityTargetAchieved.map((commodityObj, index) => {
          let AchievedChartData = {
            dimensions:
              chartData?.dimensions?.length === 4
                ? ["product", "", ...yearData]
                : ["product", ...yearData, ""],
            series: [commodityObj],
          };

          return (
            <div
              key={index}
              style={{
                display: "inline-block", // keep items in a row
                width: "250px", // fixed width per item (adjust as needed)
                verticalAlign: "top",
                padding: "10px",
              }}
            >
              <div className="d-flex justify-content-center position-relative newUiCardBody">
                <div className="position-relative">
                  {" "}
                  <CircularGaugeChart
                    value={Number(commodityObj?.targetAchieved)}
                  />
                  <div
                    className="position-absolute translate-middle-x m-1"
                    style={{
                      height: "65px",
                      width: "220px",
                      bottom: "-10px",
                      right: "-150px",
                    }}
                  >
                    <h6 className="m-0 p-0">
                      {commodityObj.product.toUpperCase()}
                    </h6>
                    <hr className="m-0 p-0" />
                    <div>
                      {}
                      <GroupedBarChart
                        data={AchievedChartData}
                        from={"AchievedChartDataCHW"}
                        chartType={"bar"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default CHWeightTargetPercentageData;
